<template>
    <div>
        <div class="mb-3" v-if="this.specs.length > 0">
            <p class="mb-2">規格</p>
            <div class="d-flex wrap spec_group">
                <div
                    v-for="item in specs"
                    :key="item.id"
                    class="spec_btn"
                    @click="specSelect(item.id, 'currentSpecs')"
                    :class="{ active: item.id == currentSpecs }"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
        <div class="mb-3" v-if="this.specsTool.length > 0">
            <p class="mb-2">用具</p>
            <div class="d-flex wrap spec_group">
                <div
                    v-for="item in specsTool"
                    :key="item.id"
                    class="spec_btn"
                    @click="specSelect(item.id, 'currentTool')"
                    :class="{ active: item.id == currentTool }"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
        <div class="mb-3" v-if="this.specsPremium.length > 0">
            <p class="mb-2">加價購</p>
            <div class="d-flex wrap spec_group">
                <div
                    v-for="item in specsPremium"
                    :key="item.id"
                    class="spec_btn"
                    @click="specSelect(item.id, 'currentPremium')"
                    :class="{ active: item.id == currentPremium }"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
        <div class="mb-3">
            <p class="mb-2">更換套餐內容</p>
            <div
                class="spec_select mb-2"
                v-for="(item, index) in change"
                :key="index"
            >
                <div class="spec_select__title">{{ item.old }}</div>
                <select v-model="selectItem[index]">
                    <option
                        v-for="option in item.new"
                        :value="option.id"
                        :key="option.id"
                    >
                        {{ option.title }}
                    </option>
                </select>
            </div>
        </div>
        <div class="qty">
            <div class="qty__btn" @click="minus()">
                <i class="bi bi-dash"></i>
            </div>
            <div class="qty__num">{{ qty }}</div>
            <div class="qty__btn" @click="add()">
                <i class="bi bi-plus"></i>
            </div>
        </div>
        <a href="" class="btn btn__basic btn__w-100 mb-2 mt-2">加入購物車</a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            qty: 1,
            specs: [], //規格
            specsTool: [
                { id: '01', title: '便利烤爐組' },
                { id: '02', title: '木炭餐用具組' },
                { id: '03', title: '無需用具' },
            ], //用具
            specsPremium: [
                { id: '01', title: '配角烤串組' },
                { id: '02', title: '海鮮拼盤組' },
                { id: '03', title: '無需加價購' },
            ], //加價購
            currentSpecs: 0,
            currentTool: 0,
            currentPremium: 0,
            change: [
                {
                    old: '雪花牛肉烤片(400g)',
                    new: [
                        { id: '01', title: '不更換' },
                        { id: '02', title: '五花豬烤片(600g)' },
                        { id: '03', title: '豬肉600g' },
                    ],
                },
                {
                    old: '五花牛培烤片(400g)',
                    new: [
                        { id: '201', title: '不更換2' },
                        { id: '202', title: '五花豬培根烤片(600g)3' },
                        { id: '203', title: '雞腿肉600g4' },
                    ],
                },
            ],
            selectItem: [],
        };
    },
    methods: {
        add() {
            this.qty++;
        },
        minus() {
            if (this.qty > 1) {
                this.qty--;
            }
        },
        specSelect(id, name) {
            if (name === 'currentTool') {
                this.currentTool = id;
            } else if (name === 'currentPremium') {
                this.currentPremium = id;
            } else {
                this.currentSpecs = id;
            }
        },
    },
    mounted() {
        if (this.specsTool.length > 0) {
            const length = this.specsTool.length;
            this.currentTool = this.specsTool[length - 1].id;
        }

        if (this.specsPremium.length > 0) {
            const length = this.specsPremium.length;
            this.currentPremium = this.specsPremium[length - 1].id;
        }
    },
};
</script>
